import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  Image,
  PinInput,
  Text,
  UnstyledButton,
} from "@mantine/core";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useMediaQuery } from "@mantine/hooks";
import useStyles from "./style";
import { resend2fa, verify2fa } from "../../services";
import { obfuscateEmail, obfuscatePhone } from "../../utils";

const TwoFactorAuthPage = () => {
  const { classes } = useStyles();
  const isResponsive = useMediaQuery("(max-width: 992px)");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [verifying, setVerifying] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const user = location?.state?.user;

  if (!user) {
    navigate("/login");
    return null; // Stop rendering
  }

  const handleVerify = async () => {
    try {
      setError("");

      if (otp?.length < 6) {
        setError("Please enter the complete 6-digit code.");
        return;
      }

      setVerifying(true);

      const values = {
        userId: user?.id,
        code: Number(otp),
      };
      const res = await verify2fa(values, navigate);

      // if (!res?.token) {
      //   navigate("/select-busniesses", { state: { res } });
      // } else {
      //   navigate("/home");
      // }
      // if (res) {
      //   navigate("/home");
      // }
    } catch (error) {
      setOtp("");
      setError("");
      setVerifying(false);
    } finally {
      setVerifying(false);
    }
  };

  const handleResend = async () => {
    try {
      
      await resend2fa({ userId: user?.id });
      setError("");
      setOtp("");
    } catch (err) {
      setError("");
      setOtp("");
      console.log("err:", err);
    }
  };

  return (
    <Grid className={classes.container}>
      {/* LEFT SIDE */}
      <Grid.Col
        xs={12}
        sm={12}
        md={5}
        className={`${classes.left_pane} ${classes.bgImg}`}
      >
        <Box className={classes.welcome}>
          <Link to={"/"}>
            <Image
              src="/assets/images/logo2.png"
              mr={"auto"}
              fit="fill"
              className={classes.logo}
            />
          </Link>
          <Box className={classes.leftSideTitle}>
            <p className={classes.titleText}>
              Simplifying <br /> Healthcare <br /> Documentation
            </p>
          </Box>
          <Text c="#000" ff={"Inter"} fz={20} fw={400}>
            Join us today to streamline your documentation process and enhance
            patient care.
          </Text>
        </Box>
      </Grid.Col>

      {/* RIGHT SIDE */}
      <Grid.Col xs={12} sm={12} md={7} className={classes.right_pane}>
        <Box className={classes.myform}>
          {isResponsive && (
            <Image
              src="assets/images/logo2.png"
              alt="logo"
              width={150}
              height={50}
              fit="fill"
            />
          )}

          <Text className={classes.title}>Two-Factor Authentication</Text>
          <Text fz={18} ff={"Inter"} color="#262626" mb="md">
            We've sent a 6-digit verification code to{" "}
            <b>
              {user?.twoFactorType === "sms"
                ? obfuscatePhone(user?.phone)
                : user?.twoFactorType === "email"
                ? obfuscateEmail(user?.email)
                : ""}
            </b>
            <br />
            Please enter it below to continue.
          </Text>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleVerify();
            }}
          >
            <Center>
              <PinInput
                length={6}
                size="xl"
                type="number"
                oneTimeCode
                value={otp}
                onChange={setOtp}
                placeholder="0"
                classNames={{
                  input: classes.pinInput,
                }}
              />
            </Center>

            {error && (
              <Text color="red" ta="center" ff="Inter" mt={10}>
                {error}
              </Text>
            )}

            <Button
              fullWidth
              size="md"
              radius="md"
              className={classes.login_btn}
              // onClick={handleVerify}
              loading={verifying}
              type="submit"
            >
              {verifying ? "Verifying..." : "Verify Code"}
            </Button>
          </form>
          <Text ta="center" ff="Inter" fz={14} color="#344054" mt="sm">
            Note: After <b>5 incorrect attempts</b>, your account will be locked
            for <b>30 minutes</b>.
          </Text>

          <Flex
            justify="center"
            align="center"
            gap={4}
            className={classes.resendLinkText}
          >
            <Text className="text">Didn’t receive the code?</Text>
            <UnstyledButton className="resendLink" onClick={handleResend}>
              Resend
            </UnstyledButton>
          </Flex>
          <Flex
            justify="center"
            gap={4}
            align="center"
            className={classes.resendLinkText}
          >
            <Text className="text">Want to use a different method?</Text>
            <UnstyledButton
              className="resendLink chooseLink"
              onClick={() =>
                navigate("/select-2fa-method", { state: { user } })
              }
            >
              Choose another
            </UnstyledButton>
          </Flex>
        </Box>
      </Grid.Col>
    </Grid>
  );
};

export default TwoFactorAuthPage;
